import { PUBLIC_API_URL } from '$env/static/public';

// Define Tag type
export interface Tag {
  hashtag: string;
  post: string;
  enabled: boolean;
}

export interface AddedTag extends Tag {
  id: number,
};

export type Tags = Record<number, AddedTag[]>;

// export type Post = [string, string, string];

export interface Cat {
  id: number,
  label: string,
};


export interface Config {
  tags: Tags,
  statuses: Cat[],
  outcomes: Cat[],
  signals: Map<string, number>,
  sweeps: number[][],
};

export async function authenticatedFetch(url: string, options: RequestInit = {
    credentials: 'include',
  }, fetchFn: any = fetch) {
    try {
      const r = await fetchFn(`${PUBLIC_API_URL}${url}`, options);

      if (r.status === 401) {
          // Redirect to login page
          window.location.href = `${PUBLIC_API_URL}/login/review-ui`;
          throw new Error('Unauthorized');
      }
      if (!r || !r.ok)
        throw new Error(`Error ${r && r.status || 'unreachable'}`);

      /* check if Content-Type is json */
      const contentType = r.headers.get('Content-Type') || '';
      return contentType == 'application/json' ? await r.json() : null;
    } catch (err) {
      console.error("fetching:", err);
      throw err;
    }
}

export function extractSearchOptions(q: string) {
    const knownOptions = ['b'];
    const fullQ: string[] = [];
    const opts: Record<string, string> = {};
    q.split(' ').forEach(p => {
      const kv = p.split(':');
      if (knownOptions.includes(kv[0])) opts[kv[0]] = kv[1];
      else fullQ.push(p);
    });
    opts.q = fullQ.join(' ');
    return opts;
}


export const SEARCH_VCAT = 1000;
export function samplesUrl(page: number, catId: number, searchInput: string) {
    const q = extractSearchOptions(searchInput.trim());
    const args: Record<string, string> = {
      q: q.q,
      cat: catId === SEARCH_VCAT ? '' : String(catId),
      page: String(page),
    };
    if (q.b) args.b = q.b;
    return `/samples?${new URLSearchParams(args)}`;
}

